import React from 'react';
import Link from '@atlaskit/link';
import { fg } from '@atlaskit/platform-feature-flags';
export var PfLink = function PfLink(_ref) {
  var href = _ref.href,
    onClick = _ref.onClick,
    id = _ref.id,
    _ref$popup = _ref.popup,
    popup = _ref$popup === void 0 ? true : _ref$popup,
    children = _ref.children;
  return fg('dst-a11y__replace-anchor-with-link__jira-service-m') ? /*#__PURE__*/React.createElement(Link, {
    href: href,
    id: id,
    rel: popup ? 'noreferrer noopener' : undefined,
    target: popup ? '_blank' : undefined,
    onClick: onClick
  }, children) :
  /*#__PURE__*/
  // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
  React.createElement("a", {
    href: href,
    id: id,
    rel: popup ? 'noreferrer noopener' : undefined,
    target: popup ? '_blank' : undefined,
    onClick: onClick
  }, children);
};